import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Dashboard = () => {
  const [kpis, setKpis] = useState(null);
  const [rates, setRates] = useState({ USD: 0, EUR: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [kpisRes, ratesRes] = await Promise.all([
        axios.get(`${API}/dashboard/kpis`),
        axios.get(`${API}/exchange-rates`)
      ]);
      setKpis(kpisRes.data);
      setRates(ratesRes.data);
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  const statusLabels = {
    'Beklemede': 'waiting',
    'Üretimde': 'production',
    'Boyamada': 'painting',
    'Montajda': 'assembly',
    'Teslim Edildi': 'delivered'
  };

  return (
    <div data-testid="dashboard-page">
      <div className="page-header">
        <h1 className="page-title">Kontrol Paneli</h1>
        <p className="page-subtitle">Doğan Vinç ERP Sistemi - Genel Bakış</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card blue" data-testid="stat-customers">
          <div className="stat-label">Toplam Müşteri</div>
          <div className="stat-value">{kpis?.total_customers || 0}</div>
        </div>
        <div className="stat-card green" data-testid="stat-orders">
          <div className="stat-label">Toplam Sipariş</div>
          <div className="stat-value">{kpis?.total_orders || 0}</div>
        </div>
        <div className="stat-card orange" data-testid="stat-active-orders">
          <div className="stat-label">Aktif Siparişler</div>
          <div className="stat-value">{kpis?.active_orders || 0}</div>
        </div>
        <div className="stat-card purple" data-testid="stat-production">
          <div className="stat-label">Üretimdeki Siparişler</div>
          <div className="stat-value">{kpis?.production_orders || 0}</div>
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginTop: 0, fontSize: '20px', fontWeight: 600 }}>Sipariş Durum Dağılımı</h2>
        <div style={{ marginTop: '20px' }}>
          {kpis?.status_distribution?.map((item, index) => (
            <div key={index} style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }} data-testid={`status-${item._id}`}>
              <span className={`badge ${statusLabels[item._id] || 'waiting'}`} style={{ marginRight: '12px', minWidth: '120px' }}>
                {item._id}
              </span>
              <div style={{ flex: 1, background: '#f1f5f9', borderRadius: '8px', height: '24px', position: 'relative' }}>
                <div style={{
                  width: `${(item.count / kpis.total_orders) * 100}%`,
                  background: 'linear-gradient(90deg, #3b82f6, #2563eb)',
                  height: '100%',
                  borderRadius: '8px',
                  transition: 'width 0.3s'
                }}></div>
              </div>
              <span style={{ marginLeft: '12px', fontWeight: 600, minWidth: '40px', textAlign: 'right' }}>{item.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="exchange-rates" data-testid="exchange-rates">
        <h3>Güncel Döviz Kurları (TCMB)</h3>
        <div className="rates-grid">
          <div className="rate-item">
            <div className="rate-label">USD</div>
            <div className="rate-value">₺{rates.USD.toFixed(2)}</div>
          </div>
          <div className="rate-item">
            <div className="rate-label">EUR</div>
            <div className="rate-value">₺{rates.EUR.toFixed(2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;